import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { subcontractorOverviewService } from '@services/subcontractor/subcontractor';
import { SubcontractorBid } from '@models/subcontractor.model';
import { useAppSelector } from '@redux/hooks';
import { RootState } from '@redux/store';

export const SUBCONTRACTOR_BIDS_QUERY_KEY = 'subcontractorBids';

export const useSubcontractorBids = (subOrganizationId: string | null): UseQueryResult<SubcontractorBid[], Error> => {
  const { organizationId } = useAppSelector((state: RootState) => state.organization);

  return useQuery({
    queryKey: [SUBCONTRACTOR_BIDS_QUERY_KEY, organizationId, subOrganizationId],
    queryFn: () => subcontractorOverviewService.getBids(subOrganizationId as string),
    enabled: !!organizationId && !!subOrganizationId,
    staleTime: 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};

export default useSubcontractorBids;
